import * as React from 'react';
export const KGSvg = React.forwardRef(function KGSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M10.5 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-5-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm5 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM8 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM4.5 6.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM8 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm3.5-3.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z',
      }),
    ),
  );
});
KGSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KG = {
  category: 'flag',
  colorable: false,
  name: 'KG',
  svg: KGSvg,
};
